<template>
  <b-modal
    id="add-user-modal"
    v-model="openModal"
    size="lg"
    title="Mise à jour de la base de donnée"
  >
    <DatastoreCreator
      :format="format"
      :resource="resource"
    />
    <template #modal-footer>
      <div class="w-100">
        <b-button
          variant="outline-secondary"
          class="float-left"
          @click="cancel"
        >
          {{ $t('buttons.cancel') }}
        </b-button>
        <b-button
          variant="primary"
          class="float-right"
          @click="updateResource"
        >
          {{ $t('buttons.confirm') }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import DatastoreCreator from '@/components/Resource/creators/DatastoreCreator.vue';

export default {
  name: 'UpdateDatastoreModal',

  components: {
    DatastoreCreator
  },

  props: {
    open: {
      type: Boolean,
      default: false
    },
    resource: {
      type: Object,
      default: null
    },
    format: {
      type: String,
      default: null
    }
  },

  data() {
    return {
      openModal: false,
    };
  },

  watch: {
    open: function(newValue) {
      this.openModal = newValue;
    },
  },
  created() {
    this.openModal = true;
  },
  methods: {
    cancel() {
      this.$emit('hide');
    },



    updateResource() {
      this.$emit('update', this.resource);
      this.$emit('hide');
    }
  }
};
</script>
